import styles from './guestcheckbox.module.scss';
import { GuestCheckboxProps } from '@msc-b2c/interfaces/types';
import React from 'react';

export const GuestCheckbox = ({
  id,
  ariaLabel,
  ariaLabelledBy,
  onChange,
  checked,
  tabIndex,
  disabled,
}: GuestCheckboxProps) => {
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (!disabled && onChange) {
      onChange(event);
    }
  };

  return (
    <div className={styles['cmp-guest-checkbox']}>
      <input
        type="checkbox"
        id={id}
        aria-label={ariaLabelledBy ? undefined : ariaLabel}
        aria-labelledby={ariaLabelledBy}
        onChange={handleChange}
        checked={checked}
        tabIndex={tabIndex || undefined}
        disabled={disabled || false}
      />
      <label htmlFor={id}></label>
    </div>
  );
};
